(function () {
  'use strict';

  var root = document.getElementById('joyfill-vip-day');
  if (!root) return;

  // Public Klaviyo identifiers. No private API key is used in the browser.
  var KLAVIYO_SITE_ID = 'QP8qfu';
  var KLAVIYO_LIST_ID = 'Xgee3W';
  var targetTime = new Date('2026-10-31T08:00:00+01:00').getTime();
  var counter = root.querySelectorAll('#cd b');

  function updateCountdown() {
    var distance = Math.max(0, targetTime - Date.now());
    var values = [
      Math.floor(distance / 86400000),
      Math.floor(distance / 3600000) % 24,
      Math.floor(distance / 60000) % 60,
      Math.floor(distance / 1000) % 60
    ];
    values.forEach(function (value, index) {
      if (counter[index]) counter[index].textContent = String(value).padStart(2, '0');
    });
  }
  updateCountdown();
  window.setInterval(updateCountdown, 1000);

  var forms = root.querySelectorAll('[data-joyfill-vip-form]');

  function showError(form, message) {
    var old = form.querySelector('.form-error');
    if (old) old.remove();
    var error = document.createElement('p');
    error.className = 'form-error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    form.appendChild(error);
  }

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = form.querySelector('[name="email"]');
      var checkbox = form.querySelector('[name="consent"]');
      var button = form.querySelector('button[type="submit"]');
      var notice = form.parentNode.querySelector('.ok');
      var previousStatus = form.querySelector('.form-status');
      if (previousStatus) previousStatus.remove();
      var previousError = form.querySelector('.form-error');
      if (previousError) previousError.remove();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!email || !email.value.trim() || !checkbox || !checkbox.checked) {
        showError(form, 'Bitte gib eine gültige E-Mail-Adresse ein und bestätige deine Einwilligung.');
        return;
      }

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      var status = document.createElement('p');
      status.className = 'form-status';
      status.setAttribute('role', 'status');
      status.textContent = 'Deine Anmeldung wird verarbeitet …';
      form.appendChild(status);

      var submissionId = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : 'vip-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Joyfill VIP Day Variation B Shopify landing page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value.trim().toLowerCase(),
                  properties: {
                    vip_submission_id: submissionId,
                    vip_campaign: 'joyfill-vip-day-variation-b',
                    vip_variant: 'B',
                    vip_page_url: window.location.href.split('#')[0]
                  },
                  subscriptions: {
                    email: {
                      marketing: { consent: 'SUBSCRIBED' }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_SITE_ID), {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify(payload)
      })
      .then(async function (response) {
        if (response.status === 202 || response.ok) {
          if (window.fbq) window.fbq('track', 'Lead');
          // Redirect only after Klaviyo accepts the subscription request.
          // The confirmation page should explain any required double-opt-in step.
          window.location.assign('/pages/vip-day-bestaetigung');
          return;
        }

        var detail = '';
        try {
          var result = await response.json();
          detail = result && result.errors && result.errors[0] && result.errors[0].detail || '';
        } catch (_) {}
        throw new Error(detail || 'Klaviyo hat die Anmeldung nicht angenommen (HTTP ' + response.status + ').');
      })
      .catch(function (error) {
        console.error('[Joyfill VIP Day] Klaviyo submission failed:', error);
        if (status.parentNode) status.remove();
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        showError(form, 'Die Anmeldung konnte nicht abgeschlossen werden. Bitte prüfe deine Angaben und versuche es erneut.');
      });
    });
  });

  var fab = root.querySelector('.fab');
  if (fab && 'IntersectionObserver' in window) {
    var seen = new Set();
    var observed = root.querySelectorAll('.kv,[data-joyfill-vip-form],.midbox,.reg2');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) seen.add(entry.target);
        else seen.delete(entry.target);
      });
      fab.classList.toggle('on', seen.size === 0);
    }, { threshold: 0.15 });
    observed.forEach(function (el) { io.observe(el); });
  } else if (fab) {
    fab.classList.add('on');
  }

  root.querySelectorAll('a[href="#reg"]').forEach(function (link) {
    link.addEventListener('click', function () {
      window.setTimeout(function () {
        var field = root.querySelector('#reg input');
        if (field) field.focus();
      }, 350);
    });
  });
})();
